const TEXT = {
    Add: {en: 'Add',ar: 'إضافة'},
    AddColumn: {en: 'Add Column',ar: 'إضافة عمود'},
    AddConstraint: {en: 'Add Constraint',ar: 'إضافة قيد'},
    AddNewColumn: {en: 'Add New Column',ar: 'إضافة عمود جديد'},
    AddPartition: {en: 'Add Partition',ar: 'إضافة تقسيم'},
    AdditionalOptions: {en: 'Additional Options',ar: 'خيارات إضافية'},
    BasicProperties: {en: 'Basic Properties',ar: 'الخصائص الأساسية'},
    Cancel: {en: 'Cancel',ar: 'إلغاء'},
    ColumnName: {en: 'Column Name',ar: 'اسم العمود'},
    ColumnType: {en: 'Column Type',ar: 'نوع العمود'},
    Columns: {en: 'Columns',ar: 'الأعمدة'},
    ConstraintType: {en: 'Constraint Type',ar: 'نوع القيد'},
    ConstraintValue: {en: 'Constraint Value',ar: 'قيمة القيد'},
    ConstraintValueHint: {en: 'Enter the constraint value or expression',ar: 'أدخل قيمة القيد أو التعبير'},
    CurrentConfiguration: {en: 'Current Configuration (JSON)',ar: 'التكوين الحالي (JSON)'},
    DbGroup: {en: 'DbGroup',ar: 'مجموعة قاعدة البيانات'},
    DbGroupName: {en: 'DbGroup Name',ar: 'اسم مجموعة قاعدة البيانات'},
    EditDbGroupTitle: {en: 'Edit DbGroup',ar: 'تعديل مجموعة قاعدة البيانات'},
    EditFieldOptions: {en: 'Edit Field Options',ar: 'تعديل خيارات الحقل'},
    EditOptions: {en: 'Options',ar: 'خيارات'},
    FieldName: {en: 'Field Name',ar: 'اسم الحقل'},
    FieldTypeOptions: {en: 'Field Type Options',ar: 'خيارات نوع الحقل'},
    HelperText: {en: 'Helper Text',ar: 'نص المساعدة'},
    Label: {en: 'Label',ar: 'تسمية'},
    MandatoryField: {en: 'Mandatory Field',ar: 'حقل إلزامي'},
    NoDbGroupsAvailable: {en: 'No DbGroups available. Please create a DbGroup first.',ar: 'لا توجد مجموعات قواعد بيانات متاحة. يرجى إنشاء مجموعة أولاً.'},
    Partition: {en: 'Partition',ar: 'تقسيم'},
    PartitionType: {en: 'Partition Type',ar: 'نوع التقسيم'},
    PartitionValue: {en: 'Partition Value',ar: 'قيمة التقسيم'},
    PartitionValueHint: {en: 'Enter partition value or configuration',ar: 'أدخل قيمة التقسيم أو التكوين'},
    Placeholder: {en: 'Placeholder',ar: 'نص تلميحي'},
    SaveChanges: {en: 'Save Changes',ar: 'حفظ التغييرات'},
    SaveOptions: {en: 'Save Options',ar: 'حفظ الخيارات'},
    SelectDbGroup: {en: 'Select DbGroup to Edit',ar: 'اختر مجموعة قاعدة البيانات للتعديل'},
    UnsavedChanges: {en: 'Unsaved Changes',ar: 'تغييرات غير محفوظة'},
    Variant: {en: 'Variant',ar: 'المتغير'},
};

export default TEXT;
